import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from "@angular/core";

import { WoundCare } from "../../../shared/types";

@Component({
	selector: "wound-care-list",
	templateUrl: "wound-care-list.component.html",
	styleUrls: ["wound-care-list.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class WoundCareListComponent {
	// @ts-expect-error TS2564
	@Input() items: WoundCare[];
	@Output() details = new EventEmitter<WoundCare>();
	@Output() pictures = new EventEmitter<WoundCare>();
}
